import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/auth/authSlice";
import { Navbar, Nav, Dropdown, Container } from "react-bootstrap";
import { Link, useNavigate  } from "react-router-dom";

function MainLayout({ children }) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isAuthenticated, user } = useSelector((state) => state.auth);
    const handleLogout = () => {
        dispatch(logout());
        navigate("/");
    };

    return (
        <div>
            <header className="d-lg-block">
                <nav className="navbar navbar-expand stellar_navbar glob_lr" id="stellar_navbar">
                    <div className="container-fluid">
                    <figure className="d-flex stellar_logo">
                        <a href="/">
                        <img 
                            src="https://www.stellarinfo.com/public/image/logo/stellar-logo.svg" 
                            alt="Stellar Logo" 
                            width="139"
                        />
                        </a>
                        <div className="exp_text">
                        <span>30 Years</span> of Excellence
                        </div>
                    </figure>

                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto">
                            {isAuthenticated ? (
                            <Dropdown>
                                <Dropdown.Toggle variant="light" id="user-dropdown">
                                {user?.email}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                <Dropdown.Item onClick={handleLogout}>
                                    Logout
                                </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            ) : (
                            <>&nbsp;</>
                            )}
                        </Nav>
                        </Navbar.Collapse>
                    </div>
                </nav>
                </header>
            <main className="conheight">{children}</main>
            <footer className="bg-dark text-white text-center p-3" >
                <p>Stellar & Stellar Data Recovery are Registered Trademarks of Stellar Information Technology Pvt. Ltd.<br/>
                © Copyright {new Date().getFullYear()} Stellar Information Technology Pvt. Ltd. All Trademarks Acknowledged.</p>
            </footer>
        </div>
    );
}
export default MainLayout;